module.exports = __webpack_public_path__ + "img/s2-0.bfb33b16.jpg";